import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Contact from "./pages/Contact";
import Price from "./pages/Price";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Contact />} />
        <Route path="/contact" element={<Navigate to="/" replace />} />
        <Route path="/price" element={<Price />} />
      </Routes>
    </Router>
  );
}

export default App;
